export const DEFAULT_FAILURE_NOTIFICATION = 'Request failed';
export const DEFAULT_SUCCESS_NOTIFICATION = 'Request successful';
